module.exports = __webpack_public_path__ + "manisa oturma odası.jpg?483607b62d7d15cf7b08b8bcfd7889e2";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/manisa oturma odası.jpg
// module id = 360
// module chunks = 0